import { MSG_RECORD_UPDATE } from "constants/common";

//JOBPROGRESS
export const METHOD_JOBPROGRESS_LIST = 'jobprogess/pageable/';
export const METHOD_JOBPROGRESS_UPDATE = 'jobprogess/{ID}/';
export const METHOD_JOBPROGRESS_DETAIL = 'jobprogess/{ID}/';
export const METHOD_JOBPROGRESS_PROCESSCHECK = 'jobprogess/processcheck/';

//language constants
export const MSG_UPDATE_RECORD = MSG_RECORD_UPDATE;